// src/mySettings/UserSettings.js
import React from 'react';
import { Routes, Route, NavLink, Navigate, useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import './UserSettings.css';
import AppTransition from '../components/appComponents/AppTransition';
import GeneralSettings from './settingComponent/accountSetting/GeneralSettings';
import IntegrationSetting from './settingComponent/accountSetting/IntegrationSetting';
import PreferenceSetting from './settingComponent/accountSetting/PeferenceSetting';
import WarningSetting from './settingComponent/accountSetting/WarningSetting';
import DescriptionTemplate from './settingComponent/creatorSetting/DescriptionTemplate';
import CommentTemplate from './settingComponent/creatorSetting/CommentTemplate';
import SelectedPlan from './settingComponent/planSetting/selectedPlan';

const UserSettings = () => {
  const location = useLocation();

  return (
    <div className="set-page">
      <AppTransition>
        <Helmet>
          <meta name="description" content="Customize your Bumpups settings." />
        </Helmet>

        <div className="set-column">
          <h1 className="set-title">Settings</h1>
          <nav className="set-tabs" aria-label="Settings sections">
            <NavLink to="/settings" end className={({ isActive }) => isActive ? 'set-tab active' : 'set-tab'}>Account</NavLink>
            <NavLink to="/settings/creator" className={({ isActive }) => isActive ? 'set-tab active' : 'set-tab'}>Creator</NavLink>
            <NavLink to="/settings/plan" className={({ isActive }) => isActive ? 'set-tab active' : 'set-tab'}>Plan</NavLink>
          </nav>

          <AppTransition key={location.key}>
            <Routes location={location}>
              <Route path="/" element={<AccountSettings />} />
              <Route path="creator" element={<CreatorSettings />} />
              <Route path="plan" element={<PlanSettings />} />
              <Route path="*" element={<Navigate to="/settings" replace />} />
            </Routes>
          </AppTransition>
        </div>
      </AppTransition>
    </div>
  );
};

const AccountSettings = () => (
  <div className="set-sections">
    <GeneralSettings />
    <IntegrationSetting />
    <PreferenceSetting />
    <WarningSetting />
  </div>
);

const CreatorSettings = () => (
  <div className="set-sections">
    <DescriptionTemplate />
    <CommentTemplate />
  </div>
);

const PlanSettings = () => (
  <div className="set-sections">
    <SelectedPlan />
  </div>
);

export default UserSettings;
